/* * @Author: 曹俊杰 * @Date: 2022-06-08 10:37:02 * @Module: 违约列表 */
<template>
  <div class="">
    <div class="SearchTop">
      <div class="SearchTop_title">查风险，就上中能曝光台</div>
      <div class="SearchTop_desc">
        收录海量已违约记录及高风险可疑名单，支持姓名、手机号、身份证等多维度检索，签约前一键查询<br />
        快速识别合作风险，让每一份合同都建立在可靠基础上！
      </div>
      <div class="search">
        <el-input v-model="search" placeholder="请输入搜索内容"></el-input>
        <el-button class="button" type="primary" icon="el-icon-search" @click="onSearch"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="table">
      <div class="title">
        <span>
          曝光列表

          <span class="desc" v-show="ShowNone">
            <span style="color: #eeeeee">｜</span>
            可查询到以下几种类型情况</span
          >
        </span>
        <el-button @click="toBaoguang" type="primary" size="small">我要曝光</el-button>
      </div>
      <div
        class="main"
        style="margin-top: 0px"
        :key="Math.random()"
        :style="ShowNone ? 'padding-bottom: 16px;' : ''"
      >
        <exposureList
          :search.sync="search"
          :tableData="ShowNone ? defaultdata : tableData"
          @onSearch="onSearch"
          :showSearch="false"
          :defaultExpandAll="ShowNone"
        />
        <hdq-pagination
          v-show="!ShowNone"
          small
          ref="pagination"
          @change="paginationChange"
          style="padding-bottom: 10px"
        />
      </div>
      <!-- <div class="none" v-show="ShowNone">
        <div class="none_box">
          <img src="@/assets/image/exposure/exposure_none_1.webp" />
          <img src="@/assets/image/exposure/exposure_none_2.webp" />
          <img src="@/assets/image/exposure/exposure_none_3.webp" />
        </div>
        <div class="none_desc">可查询到以上几种情况</div>
      </div> -->
    </div>
  </div>
</template>
<script>
import exposureList from "./components/exposureList";
import hdqPagination from "@/components/hdqPagination.vue";
export default {
  components: {
    exposureList,
    hdqPagination,
  },

  data() {
    return {
      search: "",
      tableData: [],
      ShowNone: true,
      defaultdata: [
        {
          uuid: "2b5a807242264d8b81a52a6d9bd3bb20",
          type: 1,
          name: "***名",
          idNumber: "410326***********5",
          phone: null,
          content: "拿钱跑路，同一时间还拿了其他公司签约金。",
          empName: "*串",
          companyName: "中能魔**********限公司",
          createdAt: 1748583752,
          updatedAt: 1748583752,
        },
        {
          uuid: "1980031b9262462fba66fa1ad66fd5c8",
          type: 2,
          name: "*肥",
          idNumber: "410326***********7",
          phone: null,
          content: "此人为失信人员，24年被限制消费，至今未履行",
          empName: "*串",
          companyName: "中能魔**********限公司",
          createdAt: 1748576634,
          updatedAt: 1748576634,
        },
        {
          uuid: "cfff324d18d74097acacdcae6b545068",
          type: 3,
          name: "*串",
          idNumber: "410326***********5",
          phone: null,
          content: "拿了签约费 后各种找理由不开播，也不退费 让公司去起诉",
          empName: "*串",
          companyName: "中能魔**********限公司",
          createdAt: 1748514619,
          updatedAt: 1748514619,
        },
      ],
    };
  },
  mounted() {
    this.getExposureList();
  },
  methods: {
    onSearch() {
      this.$refs.pagination.createPagination({ current: 1 });
      this.getExposureList();
    },
    async getExposureList() {
      const { current, size } = this.$refs.pagination;
      const keyword = this.search;
      if (!keyword) {
        this.ShowNone = true;
      } else {
        this.ShowNone = false;
      }
      const { status, data } = await this.$api.getExposureList({
        current,
        size,
        keyword,
      });
      if (status === 200) {
        const { records } = data;
        this.tableData = records;
        console.log("data", data);
        this.$nextTick(() => {
          this.$refs.pagination.createPagination(data);
        });
      }
    },
    paginationChange({ current, size }) {
      this.getExposureList(current, size);
    },
    toBaoguang() {
      this.$router.push({ name: "allexposureForm" });
    },
  },
};
</script>
<style lang="scss" scoped>
@use "~@/assets/style/listStyle.scss" as *;
.SearchTop {
  width: 100%;
  height: 289px;
  border-radius: 4px;
  background-image: url("~@/assets/image/exposure/exposure_bg_l.webp"),
    url("~@/assets/image/exposure/exposure_bg_r.webp"),
    url("~@/assets/image/exposure/exposure_bg.webp");
  background-size: 138px 289px, 356px 289px, auto 100%;
  background-position: left center, right center, center center;
  background-repeat: no-repeat, no-repeat, no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &_title {
    font-family: 思源黑体;
    font-size: 28px;
    font-weight: bold;
    color: #262626;
    text-shadow: 0px 4px 6px rgba(43, 125, 255, 0.15);
  }
  &_desc {
    font-size: 14px;
    line-height: 26px;
    color: #666666;
    text-align: center;
    margin-top: 16px;
  }
  .search {
    margin-top: 30px;
    width: 720px;
    height: 50px;

    box-sizing: border-box;
    border-radius: 4px;
    border: 1.5px solid #ffffff;
    background: rgba(255, 255, 255, 0.6);
    display: flex;
    padding: 0 10px;
    align-items: center;
    &::v-deep .el-input {
      .el-input__inner {
        padding-left: 0px;
        border: none;
        background: transparent;
      }
    }
  }
  .button {
    width: 76px;
    height: 34px;
    border-radius: 4px;
  }
}
.table {
  background: #ffffff;
  border-radius: 4px;
  padding: 0 16px;
  margin-top: 16px;

  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
    .desc {
      font-size: 12px;
      font-weight: 350;
      color: #666666;
    }
  }
  .main {
    margin-top: 0px;
  }
  .none {
    margin-top: 50px;
    padding-bottom: 50px;
    &_box {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 16px;
      img {
        width: 256px;
        height: 170px;
      }
    }
    &_desc {
      font-size: 14px;
      font-weight: 350;
      text-align: center;
      color: #666666;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
